import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts';
import { Card, CardContent, Typography } from '@mui/material';

const CORES = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2'];

const GraficoDespesasCategoria = ({ dados }) => {
  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(valor);
  };

  const dadosOrdenados = [...dados].sort((a, b) => b.valor - a.valor).slice(0, 8);

  return (
    <Card
      sx={{
        borderTop: '4px solid #f78b00',
        backgroundColor: '#f8f9fa',
        height: '100%'
      }}
    >
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#1f1f1f' }}>
          Despesas por Categoria - Mês Atual
        </Typography>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={dadosOrdenados} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis
              type="number"
              tick={{ fontSize: 12 }}
              stroke="#666"
              tickFormatter={(value) => `R$ ${(value / 1000).toFixed(0)}k`}
            />
            <YAxis
              dataKey="categoria"
              type="category"
              width={150}
              tick={{ fontSize: 11 }}
              stroke="#666"
            />
            <Tooltip
              formatter={(value) => formatarMoeda(value)}
              contentStyle={{
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: 4
              }}
            />
            <Bar dataKey="valor" name="Valor" radius={[0, 4, 4, 0]}>
              {dadosOrdenados.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={CORES[index % CORES.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default GraficoDespesasCategoria;
